export const formatDisplayCurrency = (
  value: number | undefined | null,
  currency?: string,
  maximumFractionDigits = 2,
): string => {
  if (value === undefined || value === null || !currency) {
    return ''
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits,
    minimumFractionDigits: 2,
  }).format(value)
}
